export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
//# sourceMappingURL=cn.js.map